import { FunctionalComponent, h } from "preact";
import { useAppSelector } from "../../redux/hooks";
import { isMobileOnly as isMobileOnlyReact } from "react-device-detect";
import { useEffect, useState } from "preact/hooks";
import styles from "./styles.css";
interface IProps {
  goHome: () => void;
}
const PortalLogo: FunctionalComponent<IProps> = ({ goHome }) => {
  const appearance = useAppSelector((state) => state.appearance);
  const isMobileOnly = appearance.narrowfactor || isMobileOnlyReact;
  const [staticLogo, setStaticLogo] = useState("");

  useEffect(() => {
    if (!appearance.logoSrc && appearance.loaded) {
      setStaticLogo("/assets/logo_icon.png");
    }
    if (appearance.logoSrc) {
      setStaticLogo(appearance.logoSrc);
    }
  }, [appearance.logoSrc, appearance.loaded]);
  // const logoImg = (appearance.backgroundImage && !appearance.logoSrc) || (
  //   <img
  //     class={
  //       appearance.mode == "widget"
  //         ? styles.widgetkorraLogo
  //         : isMobileOnly
  //         ? appearance.logoSrc
  //           ? styles.korraLogoBranded
  //           : styles.mobilekorraLogo
  //         : styles.desktopkorraLogo
  //     }
  //     src={appearance.logoSrc ? appearance.logoSrc : staticLogo}
  //   />
  // );
  return !isMobileOnly && appearance.logoSrc && appearance.loaded ? (
    <div id="logo-img">
      <span
        style={{
          cursor: "pointer",
        }}
        onClick={() => {
          if (appearance.logoHref) {
            window.open(appearance.logoHref, "_blank");
          } else {
            goHome();
          }
        }}
      >
        <img
          style={{
            height: "24px",
          }}
          src={appearance.logoSrc}
        />
      </span>
    </div>
  ) : (
    <div id="logo-img">
      <span
        style={{
          cursor: "pointer",
        }}
        onClick={() => {
          if (appearance.logoHref) {
            window.open(appearance.logoHref, "_blank");
          } else {
            goHome();
          }
        }}
      >
        {appearance.loaded && (
          <img
            class={
              appearance.mode == "widget"
                ? styles.widgetkorraLogo
                : isMobileOnly
                ? appearance.logoSrc
                  ? styles.korraLogoBranded
                  : styles.mobilekorraLogo
                : styles.desktopkorraLogo
            }
            src={appearance.logoSrc ? appearance.logoSrc : staticLogo}
          />
        )}
      </span>
    </div>
  );
};

export default PortalLogo;
